import { ConnectionsList } from './ConnectionsList';
import type { IaConnection } from '../../types/ia-landing';

interface Props {
  connections: IaConnection[] | null;
  loginUrl: string;
}

/** The "Tus conexiones" section of /ia. */
export function Connections({ connections, loginUrl }: Props) {
  return (
    <section id="conexiones" className="bg-gray-50 py-16">
      <div className="mx-auto max-w-6xl px-6">
        <h2 className="text-3xl font-extrabold text-gray-900">Tus conexiones</h2>

        <div className="mt-6">
          {connections === null ? (
            <p className="text-gray-600">
              <a href={loginUrl} className="font-semibold text-[#1EAA25] underline">Ingresá</a> para ver qué asistentes conectaste y desconectarlos.
            </p>
          ) : (
            <ConnectionsList connections={connections} />
          )}
        </div>
      </div>
    </section>
  );
}
